var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.848,
    height: 12.773,
    viewBox: "0 0 8.848 12.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_81e98e3a69bdb6690515c719833a59fa",
    "data-name": "81e98e3a69bdb6690515c719833a59fa",
    d: "M5,3V14.773M9.578,6.924,7.616,8.886m0,0,1.962,1.962M7.616,8.886h5.232",
    transform: "translate(13.348 15.273) rotate(180)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentRight);
export default __webpack_public_path__ + "static/media/alignment-right.68dddc3453b9148344a03b85a77c81a9.svg";
export { ForwardRef as ReactComponent };